import apiClient from './apiClient';

/**
 * Type pour les statistiques du tableau de bord d'une agence
 */
export interface AgencyDashboardStats {
  // Métriques de base existantes
  totalSubscribers: number;
  monthlyRevenue: number;
  activeVouchers: number;
  totalTransactions: number;
  recentTransactions: AgencyDashboardTransaction[];
  monthlyStats: AgencyDashboardMonthlyStats[];
}

/**
 * Type pour les transactions récentes dans le tableau de bord
 */
export interface AgencyDashboardTransaction {
  id: number;
  type: 'PAYMENT' | 'REFUND';
  amount: number;
  date: string;
  status: string;
}

/**
 * Type pour les statistiques mensuelles
 */
export interface AgencyDashboardMonthlyStats {
  month: string;
  subscribers: number;
  revenue: number;
}

class AgencyDashboardService {
  /**
   * Récupère les statistiques pour le tableau de bord de l'agence
   * @param dateRange Plage de dates optionnelle pour filtrer les statistiques
   */
  async getStats(dateRange?: { start: string; end: string }) {
    try {
      // Dans une implémentation réelle, on passerait dateRange en paramètre
      const response = await apiClient.get('/v1/agencies/dashboard/stats', { 
        params: dateRange 
      });
      return response;
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      
      // Pour le développement, simuler une réponse
      return {
        data: []
      };
    }
  }

  /**
   * Récupère les statistiques mensuelles pour le tableau de bord de l'agence
   * @param year Année pour laquelle récupérer les statistiques
   */
  async getMonthlyStats(year: number = new Date().getFullYear()) {
    try {
      const response = await apiClient.get(`/agency/dashboard/monthly-stats/${year}`);
      return response;
    } catch (error) {
      console.error('Error fetching monthly stats:', error);
      
      // Pour le développement, simuler une réponse
      return {
        data: [] //this.getMockMonthlyStats()
      };
    }
  }

  /**
   * Récupère les métriques de performance avancées
   */
  async getPerformanceMetrics() {
    try {
      const response = await apiClient.get('/agency/statistics/performance');
      return response;
    } catch (error) {
      console.error('Error fetching performance metrics:', error);
      return { data: {} };
    }
  }

  /**
   * Récupère les top packs vendus
   */
  async getTopPacks() {
    try {
      const response = await apiClient.get('/agency/statistics/top-packs');
      return response;
    } catch (error) {
      console.error('Error fetching top packs:', error);
      return { data: [] };
    }
  }

  /**
   * Récupère les statistiques de satisfaction client
   */
  async getCustomerSatisfaction() {
    try {
      const response = await apiClient.get('/agency/statistics/customer-satisfaction');
      return response;
    } catch (error) {
      console.error('Error fetching customer satisfaction:', error);
      return { data: { rate: 0 } };
    }
  }

  

}

export const agencyDashboardService = new AgencyDashboardService();
